export interface Property {
  id: string;
  address: string;
  city: string;
  state: 'CA' | 'NV' | 'AZ';
  zipCode: string;
  propertyType: 'Single Family' | 'Multi-Family' | 'Condo' | 'Commercial' | 'Land';
  marketValue: number;
  currentBid: number;
  auctionDays: number;
  equityPct: number;
  bedrooms: number;
  bathrooms: number;
  sqft: number;
  yearBuilt: number;
  imageUrl: string;
  badge: 'NEW' | 'AUCTION' | 'HOT DEAL' | 'PRICE DROP' | 'FEATURED';
  status: 'Active' | 'Pending' | 'Sold';
  description: string;
}

export const properties: Property[] = [
  {
    id: 'p001',
    address: '2847 Crenshaw Blvd',
    city: 'Los Angeles',
    state: 'CA',
    zipCode: '90016',
    propertyType: 'Single Family',
    marketValue: 847000,
    currentBid: 340000,
    auctionDays: 12,
    equityPct: 59.9,
    bedrooms: 4,
    bathrooms: 2,
    sqft: 2100,
    yearBuilt: 1965,
    imageUrl: 'https://public.readdy.ai/ai/img_res/5764d9f2d894c17f27c8e1afefa17fa5.jpg',
    badge: 'HOT DEAL',
    status: 'Active',
    description: 'Spacious single-family home in desirable West Adams neighborhood. Property needs cosmetic updates but has strong rental income potential.',
  },
  {
    id: 'p002',
    address: '1523 Sunrise Ave',
    city: 'Sacramento',
    state: 'CA',
    zipCode: '95825',
    propertyType: 'Single Family',
    marketValue: 520000,
    currentBid: 215000,
    auctionDays: 8,
    equityPct: 58.7,
    bedrooms: 3,
    bathrooms: 2,
    sqft: 1650,
    yearBuilt: 1978,
    imageUrl: 'https://readdy.ai/api/search-image?query=suburban%20house%20Sacramento%20California%20residential%20front%20yard%20green%20lawn%20white%20exterior%203%20bedroom%20ranch%20style%20home%20tree%20lined%20street%20summer%20day%20real%20estate&width=600&height=400&seq=prop002&orientation=landscape',
    badge: 'AUCTION',
    status: 'Active',
    description: 'Well-maintained ranch-style home in Arden Park area. Excellent school district, close to shopping and CSUS campus.',
  },
  {
    id: 'p003',
    address: '4412 Ocean View Dr',
    city: 'San Diego',
    state: 'CA',
    zipCode: '92113',
    propertyType: 'Single Family',
    marketValue: 1150000,
    currentBid: 490000,
    auctionDays: 21,
    equityPct: 57.4,
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2800,
    yearBuilt: 1990,
    imageUrl: 'https://readdy.ai/api/search-image?query=coastal%20house%20San%20Diego%20California%20white%20exterior%20modern%20Mediterranean%20architecture%20ocean%20views%20palm%20trees%20blue%20sky%20luxury%20residential%20real%20estate&width=600&height=400&seq=prop003&orientation=landscape',
    badge: 'FEATURED',
    status: 'Active',
    description: 'Stunning coastal property with partial ocean views. Open floor plan, updated kitchen, large backyard perfect for entertaining.',
  },
  {
    id: 'p004',
    address: '789 Desert Rose Ct',
    city: 'Las Vegas',
    state: 'NV',
    zipCode: '89101',
    propertyType: 'Single Family',
    marketValue: 385000,
    currentBid: 142000,
    auctionDays: 6,
    equityPct: 63.1,
    bedrooms: 3,
    bathrooms: 2,
    sqft: 1820,
    yearBuilt: 2003,
    imageUrl: 'https://readdy.ai/api/search-image?query=modern%20house%20Las%20Vegas%20Nevada%20desert%20landscaping%20tan%20exterior%20tile%20roof%20mountain%20views%20sunny%20dry%20climate%20suburban%20neighborhood%20residential&width=600&height=400&seq=prop004&orientation=landscape',
    badge: 'NEW',
    status: 'Active',
    description: 'Move-in ready desert home with low-maintenance landscaping. Covered patio, 2-car garage, mountain views from master bedroom.',
  },
  {
    id: 'p005',
    address: '3301 Lone Mountain Rd',
    city: 'Henderson',
    state: 'NV',
    zipCode: '89002',
    propertyType: 'Multi-Family',
    marketValue: 695000,
    currentBid: 278000,
    auctionDays: 15,
    equityPct: 60.0,
    bedrooms: 6,
    bathrooms: 4,
    sqft: 3400,
    yearBuilt: 1999,
    imageUrl: 'https://readdy.ai/api/search-image?query=duplex%20multi-family%20home%20Henderson%20Nevada%20beige%20tan%20stucco%20exterior%20two%20units%20double%20garage%20desert%20southwest%20architecture%20residential%20investment%20property&width=600&height=400&seq=prop005&orientation=landscape',
    badge: 'HOT DEAL',
    status: 'Active',
    description: 'Income-producing duplex in prime Henderson location. Both units currently vacant, ready for renovation and immediate rental.',
  },
  {
    id: 'p006',
    address: '6120 Sunridge Way',
    city: 'Reno',
    state: 'NV',
    zipCode: '89502',
    propertyType: 'Single Family',
    marketValue: 440000,
    currentBid: 175000,
    auctionDays: 18,
    equityPct: 60.2,
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2250,
    yearBuilt: 1988,
    imageUrl: 'https://readdy.ai/api/search-image?query=mountain%20view%20house%20Reno%20Nevada%20pine%20trees%20surroundings%20two%20story%20exterior%20wood%20siding%20green%20foliage%20suburbs%20residential%20real%20estate%20clear%20day&width=600&height=400&seq=prop006&orientation=landscape',
    badge: 'AUCTION',
    status: 'Active',
    description: 'Spacious mountain-view home near UNR. Updated bathrooms, hardwood floors throughout, large deck with Sierra Nevada views.',
  },
  {
    id: 'p007',
    address: '9844 Camelback Rd',
    city: 'Phoenix',
    state: 'AZ',
    zipCode: '85016',
    propertyType: 'Single Family',
    marketValue: 620000,
    currentBid: 242000,
    auctionDays: 10,
    equityPct: 61.0,
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2650,
    yearBuilt: 1995,
    imageUrl: 'https://readdy.ai/api/search-image?query=modern%20ranch%20house%20Phoenix%20Arizona%20desert%20southwest%20architecture%20pool%20terracotta%20tiles%20saguaro%20cactus%20sunny%20exterior%20warm%20tones%20luxury%20residential&width=600&height=400&seq=prop007&orientation=landscape',
    badge: 'FEATURED',
    status: 'Active',
    description: 'Luxury Camelback corridor home with private pool and spa. Gourmet kitchen, split floor plan, excellent Scottsdale school district.',
  },
  {
    id: 'p008',
    address: '2290 E Speedway Blvd',
    city: 'Tucson',
    state: 'AZ',
    zipCode: '85716',
    propertyType: 'Commercial',
    marketValue: 890000,
    currentBid: 355000,
    auctionDays: 25,
    equityPct: 60.1,
    bedrooms: 0,
    bathrooms: 2,
    sqft: 4800,
    yearBuilt: 1982,
    imageUrl: 'https://readdy.ai/api/search-image?query=commercial%20property%20Tucson%20Arizona%20strip%20mall%20retail%20building%20desert%20architecture%20beige%20exterior%20parking%20lot%20southwest%20style%20sunny%20day%20real%20estate&width=600&height=400&seq=prop008&orientation=landscape',
    badge: 'NEW',
    status: 'Active',
    description: 'Prime commercial strip with three retail units on busy Speedway corridor. High visibility, strong rental income opportunity.',
  },
  {
    id: 'p009',
    address: '1177 Via Del Tesoro',
    city: 'Scottsdale',
    state: 'AZ',
    zipCode: '85255',
    propertyType: 'Single Family',
    marketValue: 1350000,
    currentBid: 520000,
    auctionDays: 30,
    equityPct: 61.5,
    bedrooms: 5,
    bathrooms: 4,
    sqft: 4200,
    yearBuilt: 2005,
    imageUrl: 'https://readdy.ai/api/search-image?query=luxury%20mansion%20Scottsdale%20Arizona%20desert%20modern%20architecture%20pool%20patio%20terracotta%20exterior%20granite%20mountain%20views%20gated%20community%20high%20end%20real%20estate&width=600&height=400&seq=prop009&orientation=landscape',
    badge: 'PRICE DROP',
    status: 'Active',
    description: 'Trophy property in prestigious North Scottsdale. Resort-style pool, 4-car garage, breathtaking McDowell mountain views.',
  },
  {
    id: 'p010',
    address: '3822 Figueroa St',
    city: 'Fresno',
    state: 'CA',
    zipCode: '93705',
    propertyType: 'Single Family',
    marketValue: 295000,
    currentBid: 110000,
    auctionDays: 4,
    equityPct: 62.7,
    bedrooms: 3,
    bathrooms: 1,
    sqft: 1280,
    yearBuilt: 1955,
    imageUrl: 'https://readdy.ai/api/search-image?query=vintage%20bungalow%20house%20Fresno%20California%20post%20war%20era%20neighborhood%20mature%20trees%20front%20porch%20wood%20exterior%20residential%20street%20mid%20century%20real%20estate&width=600&height=400&seq=prop010&orientation=landscape',
    badge: 'AUCTION',
    status: 'Active',
    description: 'Classic California bungalow with huge upside potential. Large lot, detached garage, centrally located near Tower District.',
  },
  {
    id: 'p011',
    address: '5540 W Cholla St',
    city: 'Glendale',
    state: 'AZ',
    zipCode: '85302',
    propertyType: 'Single Family',
    marketValue: 420000,
    currentBid: 162000,
    auctionDays: 9,
    equityPct: 61.4,
    bedrooms: 4,
    bathrooms: 2,
    sqft: 1950,
    yearBuilt: 1998,
    imageUrl: 'https://readdy.ai/api/search-image?query=suburban%20home%20Glendale%20Arizona%20beige%20stucco%20exterior%20desert%20landscaping%20front%20yard%20tile%20roof%20two%20car%20garage%20family%20home%20southwest%20style&width=600&height=400&seq=prop011&orientation=landscape',
    badge: 'HOT DEAL',
    status: 'Active',
    description: 'Move-in ready family home in established Glendale neighborhood. New HVAC system, updated flooring, large backyard with citrus trees.',
  },
  {
    id: 'p012',
    address: '742 Linden Ave',
    city: 'San Bernardino',
    state: 'CA',
    zipCode: '92408',
    propertyType: 'Multi-Family',
    marketValue: 560000,
    currentBid: 219000,
    auctionDays: 14,
    equityPct: 60.9,
    bedrooms: 6,
    bathrooms: 3,
    sqft: 2900,
    yearBuilt: 1972,
    imageUrl: 'https://readdy.ai/api/search-image?query=triplex%20apartment%20building%20San%20Bernardino%20California%20residential%20older%20neighborhood%20three%20units%20investment%20property%20exterior%20driveway%20Southern%20California%20real%20estate&width=600&height=400&seq=prop012&orientation=landscape',
    badge: 'NEW',
    status: 'Active',
    description: 'Triplex investment opportunity in revitalizing Inland Empire market. Strong rental demand, all units individually metered.',
  },
];
